import { render } from "./HowItWorks3Icon.vue?vue&type=template&id=1286366a"
import script from "./HowItWorks3Icon.vue?vue&type=script&lang=js"
export * from "./HowItWorks3Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__